<template>
  <CommonPages id="disclaimer" :class="['resources-page']" titlePrefix="Disclaimer"
    :metaDescription="domainConfig?.['meta']?.des || 'Disclaimer'">

    <div class="resources-row">
      <div class="resources">
        <!-- 页面主标题 -->
        <h2 class="resources__title">Disclaimer</h2>

        <div class="resources__content">
          <p>
            The information and stories provided on {{ domainConfig?.siteName }} (the "Website") are for entertainment and informational purposes only. By using this Website, you acknowledge and agree to the following:
          </p>
        </div>

        <h3 class="resources__subtitle">1. AI-Generated Content Notice</h3>
        <div class="resources__content">
          <p>All novels, stories, and narratives on this platform are generated by Artificial Intelligence (AI). While we strive for quality, these stories are created by algorithms, not human authors. Consequently:</p>
          <ul>
            <li><strong>Inconsistencies:</strong> Content may contain plot holes, grammatical errors, or logical inconsistencies.</li>
            <li><strong>No Human Intent:</strong> The stories do not reflect the personal opinions, beliefs, or intentions of the Website owners or developers.</li>
          </ul>
        </div>

        <h3 class="resources__subtitle">2. No Guarantee of Accuracy</h3>
        <div class="resources__content">
          <p>
            We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of the information contained in the AI-generated stories. Any reliance you place on such information is strictly at your own risk.
          </p>
        </div>

        <h3 class="resources__subtitle">3. Content Sensitivities and "Offense" Disclaimer</h3>
        <div class="resources__content">
          <p>
            AI models are trained on vast datasets and may occasionally generate content that some readers find biased, offensive, or inappropriate. {{ domainConfig?.siteName }} does not endorse any specific viewpoints expressed in AI-generated text. We implement filters to minimize such occurrences, but we cannot guarantee that the content will always be free of objectionable material.
          </p>
        </div>

        <h3 class="resources__subtitle">4. Fictionality and Resemblance</h3>
        <div class="resources__content">
          <p>
            All characters, names, businesses, places, events, and incidents in the stories are either the products of the AI’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.
          </p>
        </div>

        <h3 class="resources__subtitle">5. Health, Legal, and Professional Advice</h3>
        <div class="resources__content">
          <p>
            AI-generated stories may occasionally mention medical, legal, or professional topics. Such content is not professional advice and should never be treated as such. Always seek the advice of a qualified professional for any serious matters.
          </p>
        </div>

        <h3 class="resources__subtitle">6. Limitation of Liability</h3>
        <div class="resources__content">
          <p>
            In no event will {{ domainConfig?.siteName }}, its owners, or employees be liable for any loss or damage, including without limitation, indirect or consequential loss or damage, arising from the use of this Website or the consumption of its AI-generated content.
          </p>
        </div>

        <h3 class="resources__subtitle">7. External Links</h3>
        <div class="resources__content">
          <p>
            Through this Website, you may be able to link to other websites which are not under the control of {{ domainConfig?.siteName }}. We have no control over the nature, content, and availability of those sites.
          </p>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/resources.scss'

export default {
  name: 'Disclaimer',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script>
